import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // <--- ВОТ ЭТА ВАЖНАЯ СТРОКА
import App from './App';
import './i18n';
document.documentElement.classList.remove('app-light');

const isIgnoredExtensionError = ({ message = '', stack = '', filename = '' }) => {
  const normalizedMessage = String(message).toLowerCase();
  const normalizedStack = String(stack).toLowerCase();
  const normalizedFilename = String(filename).toLowerCase();

  const isProviderConflict = normalizedMessage.includes('cannot redefine property: ethereum')
    || normalizedStack.includes('cannot redefine property: ethereum');
  const isExtensionSource = normalizedFilename.includes('chrome-extension://')
    || normalizedStack.includes('chrome-extension://');

  return isProviderConflict && isExtensionSource;
};

window.addEventListener('error', (event) => {
  if (!isIgnoredExtensionError({
    message: event.message,
    stack: event.error?.stack,
    filename: event.filename
  })) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation?.();
}, true);

window.addEventListener('unhandledrejection', (event) => {
  if (!isIgnoredExtensionError({
    message: event.reason?.message || event.reason,
    stack: event.reason?.stack
  })) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation?.();
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
